import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

import { StonesBannerAbilities } from '@app/shared/ui/organisms/Cognition/StonesBannerAbilities';
import { StonesBannerDescription } from '@app/shared/ui/organisms/Cognition/StonesBannerDescription';
import { Page } from '@app/routes';
import { telegramVibrate } from '@app/shared/utils/common';

export const StonesBanner = () => {
  const navigate = useNavigate();

  const handleBannerClick = useCallback(() => {
    telegramVibrate();
    navigate(Page.STONE_ABILITIES);
  }, []);

  return (
    <div
      onClick={handleBannerClick}
      className="flex min-h-[213px] cursor-pointer gap-[4px] overflow-hidden rounded-2xl bg-[linear-gradient(110.7deg,#E9F5FA_2.83%,#80BDFA_106.17%)] p-[14px_0_0_9px]"
    >
      <StonesBannerDescription />
      <StonesBannerAbilities />
    </div>
  );
};
